var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5326 20.388L12.0475 19.472C12.4465 18.762 12.646 18.406 12.9671 18.21C13.2882 18.013 13.692 18.006 14.4995 17.991C15.6927 17.97 16.4403 17.893 17.0674 17.619C17.6437 17.3677 18.1673 16.9994 18.6084 16.5351C19.0495 16.0708 19.3993 15.5196 19.6381 14.913C20 13.995 20 12.83 20 10.5V9.5C20 6.227 20 4.59 19.2999 3.388C18.9084 2.7152 18.3713 2.14945 17.7324 1.737C16.5895 1 15.0343 1 11.925 1H9.075C5.96565 1 4.4105 1 3.2686 1.737C2.62944 2.14904 2.09198 2.71445 1.70015 3.387C1 4.59 1 6.228 1 9.5V10.5C1 12.83 1 13.995 1.361 14.913C1.59982 15.5197 1.94985 16.071 2.3911 16.5353C2.83235 16.9996 3.35617 17.3678 3.93265 17.619C4.55965 17.893 5.3073 17.969 6.5005 17.991C7.308 18.006 7.71175 18.013 8.03285 18.21C8.353 18.406 8.55345 18.761 8.95245 19.472L9.46735 20.388C9.9262 21.204 11.0729 21.204 11.5326 20.388ZM14.3 11C14.552 11 14.7936 10.8946 14.9718 10.7071C15.1499 10.5196 15.25 10.2652 15.25 10C15.25 9.73478 15.1499 9.48043 14.9718 9.29289C14.7936 9.10536 14.552 9 14.3 9C14.048 9 13.8064 9.10536 13.6282 9.29289C13.4501 9.48043 13.35 9.73478 13.35 10C13.35 10.2652 13.4501 10.5196 13.6282 10.7071C13.8064 10.8946 14.048 11 14.3 11ZM11.45 10C11.45 10.2652 11.3499 10.5196 11.1718 10.7071C10.9936 10.8946 10.752 11 10.5 11C10.248 11 10.0064 10.8946 9.82825 10.7071C9.65009 10.5196 9.55 10.2652 9.55 10C9.55 9.73478 9.65009 9.48043 9.82825 9.29289C10.0064 9.10536 10.248 9 10.5 9C10.752 9 10.9936 9.10536 11.1718 9.29289C11.3499 9.48043 11.45 9.73478 11.45 10ZM6.7 11C6.95196 11 7.19359 10.8946 7.37175 10.7071C7.54991 10.5196 7.65 10.2652 7.65 10C7.65 9.73478 7.54991 9.48043 7.37175 9.29289C7.19359 9.10536 6.95196 9 6.7 9C6.44804 9 6.20641 9.10536 6.02825 9.29289C5.85009 9.48043 5.75 9.73478 5.75 10C5.75 10.2652 5.85009 10.5196 6.02825 10.7071C6.20641 10.8946 6.44804 11 6.7 11Z",
    fill: "#178EFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9991 9.625H14.007",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4952 9.625H10.5031",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99609 9.625H7.00395",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveChatIcon);
export default __webpack_public_path__ + "static/media/active-chat-icon.bedca95dcd9bcf88610b39f956dfc802.svg";
export { ForwardRef as ReactComponent };